<template>
  <div class="container education-details my-4">
    <div class="component-header mb-4">
      <h1>Lekcja</h1>
      <div class="ml-4 add-edit-actions">
        <button type="submit" form="education-details" class="action">
          <i class="fa fa-floppy-o" aria-hidden="true"></i>
        </button>
        <button data-toggle="modal" data-target="#educationDetails" class="action">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
      </div>
      <div
        class="saved-text ml-3"
        v-bind:class="[showMessage ? 'visible' : 'hidden', success ? 'text-success' : 'text-danger']"
      >
        {{ messageText }}
      </div>
    </div>
   <form id="education-details" @submit.prevent="save">
      <div class="form-group">
        <label for="name">Tytuł*</label>
        <input
          type="text"
          class="form-control"
          id="educationTitle"
          v-model="material.title"
          required
          maxlength="50"
        />
        <small class="form-text text-muted">Pole obowiązkowe</small>
      </div>
      <div class="form-group">
        <label for="lastName" required>Streszczenie*</label>
        <textarea 
          class="form-control"
          id="educationSummary"
          v-model="material.summary"
          required
          maxlength="200"
          rows="3"
        />
        <small class="form-text text-muted">Pole obowiązkowe</small>
      </div>
      <div class="form-group" style="padding-bottom: 30px;">
        <label >Plik</label>
        <div v-if="!material.fileData">
          <input type="file" @change="onFileChange" ref="fileInput" name="fileUp" id="fileUp" class="inputFile">
        </div>
        <div v-if="material.fileData">
          <label style="font-weight: bold; font-size: 20px;">Nazwa: {{material.downloadFile}}</label>
          <button
                type="button"
                style="font-size: 20; margin-top: 5px; margin-left: 30px;"
                class="btn btn-dark"
                aria-label="Usuń"
                @click="removeFile()"
              >
               <span aria-hidden="true">Usuń plik</span>
          </button>
        </div>
      </div>
      <div class="form-row justify-content-md-center">
        <div class="form-group">
          <div class="form-group col-md-6 justify-content-center">
            <div v-if="material.imageData">
              <img
                id="card-image"
                :src="material.imageData"
                width="300"
                height="300"
              />
              <button
                type="button"
                style="font-size: 20; margin-top: 20px; margin-left: 100px;"
                class="btn btn-dark"
                aria-label="Usuń"
                @click="removeImage()"
              >
                <span aria-hidden="true">Usuń</span>
              </button>
            </div>
            <picture-input
              v-if="!material.imageData"
              ref="pictureInput"
              @change="onChange"
              id="projectPicture"
              style="z-index: 1; width: 300px; height: 300px"
              margin="16"
              accept="image/jpeg,image/png"
            >
            </picture-input>
          </div>
        </div>
      </div>
    </form>
    <Modal v-bind:settings="modalSettings" @confirm="goBack()" />
  </div>
</template>

<script>
import Modal from "./Modal";
import PictureInput from "vue-picture-input";
export default {
  components: {
    Modal,
    PictureInput
  },
  data() {
    return {
      material: {},
      modalSettings: {
        body: "Czy na pewno chcesz wyjść? Niezapisane zmiany zostaną utracone.",
        modalId: "educationDetails",
      },
      messageText: "",
      showMessage: false,
      id: null,
      success:false
    };
  },
  methods: {
    initialize: function () {
      this.id = this.$route.params.id;
      if (this.id) {
        this.$api.getEducationMaterialById(this.id).then((data) => {
          this.material = data;
        });
      }
    },
    save: function () {
      if (this.id) {
        this.update(this.material);
      } else {
        this.create(this.material);
      }
    },
    update: function (data) {
      this.$api.updateEducationMaterial(data).then((data) => {
        if (data.ok) {
          this.displaySucess();
        } else {
          this.displayFailure();
        }
      });
    },
    create: function (data) {
      this.$api.createEducationMaterial(data).then((data) => {
        if (data.ok) {
          this.displaySucess();
          this.goBack();
        } else {
          this.displayFailure();
        }
      });
    },
    removeImage() {
      this.material.imageData = null;
    },
    removeFile() {
      this.material.fileData = null;
    },
    createBase64Image(fileObject) {
      const reader = new window.FileReader();
      let self = this;
      reader.onloadend = function (event) {
        try {
          let res = event.target.result;
          self.material.imageData = res;
        } catch (err) {
          alert("Error: " + err);
        }
      };
      reader.readAsDataURL(fileObject);
    },
    onChange() {
      console.log("Picture changed!");
      if (this.$refs.fileInput.file) {
        this.createBase64Image(this.$refs.fileInput.file);
      } else {
        console.log("Old browser. No support for Filereader API");
      }
    },
    createBase64File(fileObject) {
      const reader = new window.FileReader();
      let self = this;
      reader.onloadend = function (event) {
        try {
          let res = event.target.result;
          self.material.fileData = res;
        } catch (err) {
          alert("Error: " + err);
        }
      };
      reader.readAsDataURL(fileObject);
    },
    onFileChange(e) {
      console.log("File changed!");
      let files = e.target.files || e.dataTransfer.files;
      if (files.length) {
        this.createBase64File(files[0]);
        this.material.downloadFile = files[0].name;
      } else {
        console.log("Old browser. No support for Filereader API");
      }
    },
    displaySucess: function () {
      this.messageText = "Dane zostały pomyślnie zapisane";
      this.showMessage = true;
      this.success = true;
      setTimeout(() => (this.showMessage = false), 3000);
    },
    displayFailure: function () {
      this.messageText = "Wystąpił błąd w zapisie danych";
      this.showMessage = true;
      this.success = false;
      setTimeout(() => (this.showMessage = false), 3000);
    },
    goBack() {
      console.log(this.id);
      this.$router.push({ name: "Education" });
    },
    goBackWithSave() {
      this.save();
      this.goBack();
    },
  },
  created() {
    this.initialize();
  },
  beforeRouteUpdate(to, from, next) {
    this.initialize();
    next();
  },
};
</script>

<style>
#bibliographyContent {
  height: 800px;
}
.ql-toolbar {
  position: -webkit-sticky;
  position: sticky;
  top: 116px;
  z-index: 100;
  background: white;
}

</style>